var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-groups" }, [
    _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "title" }, [
        _c("div", { staticClass: "title-content" }, [
          _c(
            "span",
            {
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  _vm.selectedCustomerGroup = null
                },
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("wp.customerGroups")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.selectedCustomerGroup
            ? _c("span", [
                _vm._v(" > " + _vm._s(_vm.selectedCustomerGroup.name) + " "),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    !_vm.selectedCustomerGroup
      ? _c(
          "div",
          [
            _c("supsis-table", {
              attrs: {
                columns: _vm.getGroupColumns(),
                rows: _vm.customerGroups,
              },
            }),
          ],
          1
        )
      : _c(
          "div",
          [
            _c("div", { staticClass: "group-detail-description" }, [
              _vm._v(_vm._s(_vm.selectedCustomerGroup.description)),
            ]),
            _vm._v(" "),
            _c("supsis-table", {
              attrs: {
                columns: _vm.getContactColumns(),
                rows: _vm.contacts,
                "pagination-cursor": _vm.paginationCursor,
                "top-pagination": true,
                "bottom-pagination": true,
              },
              on: { "cursor-changed": _vm.paginationChanged },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }